import React, { useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import '../SurveyAnswer.less';
import area from '../../../../utils/areas';

// 地区选择题
const MvpRegion: React.FC = ({ body, id, required, optionList, num, form }: { body?: string; required?: boolean; num?: number; id?: number; form?: any; optionList?: any }) => {
    const [cities, setCities] = useState([]);
    const [districts, setDistricts] = useState([]);

    const handleProvinceChange = (value: string) => {
        let city: any[] = area.filter((item: any) => item.code === value);
        setCities(city[0].cities);
        setDistricts(city[0].cities[0].districts);
        form.setFieldValue(`${id}-7`, [value]);
    };

    const onSecondCityChange = (value: string) => {
        let county: any[] = cities.filter((item: any) => item.code === value);
        let currentForm = form.getFieldValue(`${id}-7`);
        setDistricts(county[0].districts);
        currentForm[2] = '';
        form.setFieldValue(`${id}-7`, currentForm);
    };

    const onThirdCountyChange = (value: string) => {
        let currentForm = form.getFieldValue(`${id}-7`);
        currentForm[2] = value;
        form.setFieldValue(`${id}-7`, currentForm);
    };

    // 设置表单回显
    const setRegionContent = (values: any) => {
        if (values && values.length) {
            let city: any[] = area.filter((item: any) => item.code === values[0]);
            if (city && city.length) {
                setCities(city[0].cities);
            }
            if (values[1] && city && city.length) {
                let district: any[] = city[0].cities.filter((item: any) => item.code === values[1]);
                if (district && district.length) {
                    setDistricts(district[0].districts);
                }
            }
        }
        form.setFieldValue(`${id}-7`, values);
    };

    // 接口回显数据
    useEffect(() => {
        if (optionList && optionList.length && optionList[0].content) {
            let values = optionList[0].content.split(',');
            setRegionContent(values);
        }
    }, [optionList]);

    // 本地实时保存回显数据
    useEffect(() => {
        let formData = localStorage.getItem('formData');
        if (formData) {
            let values = JSON.parse(formData)[`${id}-7`];
            setRegionContent(values);
        }
    }, []);

    return (
        <>
            <Form.Item name={`${id}-7`} rules={[{ required, message: '该题为必答题，请作答后提交。' }]} label={num + '. ' + body}>
                <div className="fill-topic">
                    <Form.Item name={[`${id}-7`, 0]} rules={[{ required, message: '' }]} label="" style={{ marginRight: '0.1rem' }}>
                        <Select
                            className="region-select"
                            allowClear={true}
                            placeholder="省份"
                            onChange={handleProvinceChange}
                            options={area.map(item => ({
                                label: item.name,
                                value: item.code,
                            }))}
                        />
                    </Form.Item>
                    <Form.Item name={[`${id}-7`, 1]} rules={[{ required, message: '' }]} label="" style={{ marginRight: '0.1rem' }}>
                        <Select
                            className="region-select"
                            allowClear={true}
                            placeholder="城市"
                            onChange={onSecondCityChange}
                            options={cities.map((item: any) => ({
                                label: item.name,
                                value: item.code,
                            }))}
                        />
                    </Form.Item>
                    <Form.Item name={[`${id}-7`, 2]} rules={[{ required, message: '' }]} label="">
                        <Select
                            className="region-select"
                            allowClear={true}
                            placeholder="区县"
                            onChange={onThirdCountyChange}
                            options={districts.map((item: any) => ({
                                label: item.name,
                                value: item.code,
                            }))}
                        />
                    </Form.Item>
                </div>
            </Form.Item>
        </>
    );
};

export default MvpRegion;
